import * as React from 'react';
import { MainMenuProps, MainMenuState, MenuItemModel } from './MainMenu.types';
import { MenuItem } from './MenuItem';
import { KeyboardEventKeys } from '../../utils/keyboardEventKeys';

/**
 * An accessible menu component. It is possible to navigate with keyboard.
 */
export class MainMenu extends React.Component<MainMenuProps, MainMenuState> {
  private _navElement: React.RefObject<HTMLElement>;
  constructor(props: MainMenuProps) {
    super(props);
    this._navElement = React.createRef();
    const levelOneMenuItems = [];
    props.startpage.Children.forEach((child, i) => {
      levelOneMenuItems.push({
        item: child,
        index: i,
        focusCb: this.itemRecievedFocus,
        key: child.Url,
      } as MenuItemModel);
    });

    this.state = {
      levelOneMenuItems,
      focusedIndex: -1,
      menuHasExpandedDropMenu: false,
    };
  }

  /**
   * Register keydown events for the navigation element
   */
  componentDidMount = () => {
    // Scope keydown event to only _navElement and its descendants
    this._navElement.current.addEventListener('keydown', (e) => {
      switch (e.key) {
        case KeyboardEventKeys.arrowDown:
          this.arrowDownPressed(e);
          break;
        case KeyboardEventKeys.arrowLeft:
          this.arrowLeftOrRightPressed(this.state.focusedIndex - 1);
          break;
        case KeyboardEventKeys.arrowRight:
          this.arrowLeftOrRightPressed(this.state.focusedIndex + 1);
          break;
        case KeyboardEventKeys.esc || KeyboardEventKeys.tab:
          this.setState({ menuHasExpandedDropMenu: false });
          break;
      }
    });

    // focusout bubbles up to _navElement
    this._navElement.current.addEventListener('focusout', (e: FocusEvent) => {
      if (!this._navElement.current.contains(e.relatedTarget as Node)) {
        this.setState({
          focusedIndex: -1,
        });
      }
    });
  };

  arrowLeftOrRightPressed = (index: number) => {
    const { levelOneMenuItems } = this.state;
    // If index is out of bounds, do nothing
    if (index < 0 || index >= levelOneMenuItems.length) return;

    // Set new index, close drops if any is open
    this.setState({
      focusedIndex: index,
      menuHasExpandedDropMenu: false,
    });
  };

  arrowDownPressed = (e: KeyboardEvent) => {
    const { focusedIndex, levelOneMenuItems } = this.state;
    if (focusedIndex > -1) {
      // Prevents browser window scrolling down
      e.preventDefault();

      // if the current item has children when arrowDown is pressed, set isExpanded to true, else false
      this.setState({
        focusedIndex,
        menuHasExpandedDropMenu: levelOneMenuItems[focusedIndex].item.HasChildren,
      });
    }
  };

  itemRecievedFocus = (index: number) => {
    this.setState({
      focusedIndex: index,
    });
  };

  public render() {
    const { focusedIndex, menuHasExpandedDropMenu } = this.state;
    return (
      <nav
        ref={this._navElement}
        className="main-navigation"
        id="main-nav"
        aria-label={this.props.arialabelMainNav ? this.props.arialabelMainNav : 'Huvudnavigering'}>
        <ul className="main-navigation__topnav">
          {this.props.isCampaignPage && (
            <li>
              {' '}
              <a
                href={this.props.node.Url}
                className={`main-navigation__link main-navigation__toplink ${
                  this.props.isCampaignStartPage ? 'main-navigation__active' : null
                }`}>
                {this.props.node.Name}
              </a>
            </li>
          )}
          {this.state.levelOneMenuItems.map((child) => {
            return (
              <MenuItem focusedIndex={focusedIndex} menuHasExpandedDropMenu={menuHasExpandedDropMenu} {...child} />
            );
          })}
        </ul>
      </nav>
    );
  }
}
